import * as React from 'react';
import Styled from 'styled-components';

import SVGIcon, { ISVGIconProps, VALID_ICONS } from '../../Icon/SVGIcon';
import { media } from '../../../lib/StyledComponents';
import { ListNumber } from '../../List/ListNumber';
import { ListNumberElement } from '../../List';

export const VerSnapshotList = Styled(ListNumber)`
  font-size: 1.6rem;
  line-height: 1.4;
`;

VerSnapshotList.displayName = 'VerSnapshotList';

const iconSize: string = '35px';

const VerSnapshotElement = Styled(ListNumberElement)`
  position: relative;

  ${media.small`
    margin-bottom: 2em;
    padding-left: 4.5em;

    &::before {
      left: calc(${iconSize} + 1em);
    }
  `}
`;

const VerSnapshotIconWrap = Styled.div`
  display: none;

  ${media.small`
    width: ${iconSize};
    height: ${iconSize};
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  `}
`;

const VerSnapshotIcon = Styled(SVGIcon)<ISVGIconProps>`
  ${media.small`
    width: ${iconSize};
    height: 100%;
    display: block;
  `}
`;

export const VerSnapshotListElement: React.FunctionComponent<
  React.HtmlHTMLAttributes<HTMLLIElement> & { icon: VALID_ICONS }
> = ({ children, icon, ...props }) => (
  <VerSnapshotElement {...props}>
    <VerSnapshotIconWrap>
      <VerSnapshotIcon icon={icon} />
    </VerSnapshotIconWrap>
    {children}
  </VerSnapshotElement>
);

VerSnapshotListElement.displayName = 'VerSnapshotListElement';
